import { Ability, AbilityBuilder } from '@casl/ability'
import store from '../store/index'
import * as authenticationTypes from '../store/modules/authentication-mutation-types'
import { User } from '../models'

function subjectName (item) {
  if (!item || typeof item === 'string') {
    return item
  }
  return item.__type
}

const ability = new Ability([], { subjectName })

let currentUser

store.subscribe((mutation, state) => {
  if (mutation.type === 'authentication/' + authenticationTypes.FETCH_USER_SUCCESS) {
    const prevUser = currentUser
    currentUser = new User(state.authentication.user)
    if (currentUser !== null && (
      prevUser === undefined ||
      prevUser.id === undefined ||
      prevUser.id !== currentUser.id
    )
    ) {
      ability.update(defineRulesFor(currentUser))
    }
  }
})

function defineRulesFor (user) {
  const { can, rules } = new AbilityBuilder()

  if (user.position === 2) {
    can('perform', 'CovidTests')
  }

  return rules
}

export default ability
